module.exports = __webpack_public_path__ + "img/marker_two_cyan1.5180e62c.png";